import React, { Fragment } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { VehicleReportSettings } from '../../../../core/api/models';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import validator from 'validator';

const UpdateForm: React.FunctionComponent<{
  onSubmit: (data: VehicleReportSettings) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  data?: VehicleReportSettings;
  error?: string;
}> = (props) => {
  const {
    control,
    handleSubmit,
    errors,
    watch,
  } = useForm<VehicleReportSettings>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    shouldUnregister: true,
    defaultValues: props.data,
  });

  const renderHeadingBackgroundColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Grid Header Background Color
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Grid Header Background Color is required',
            }}
            name="headingBackgroundColor"
            defaultValue={props.data?.headingBackgroundColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Grid Header Background Color"
                name={name}
                value={value}
                onChange={onChange}
                id="headingBackgroundColor"
              />
            )}
          />
          <ErrorMessage>{errors.headingBackgroundColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderHeadingFontColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Grid Header Font Color
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Grid Header Font Color is required',
            }}
            name="headingFontColor"
            defaultValue={props.data?.headingFontColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Grid Header Font Color"
                name={name}
                value={value}
                onChange={onChange}
                id="headingFontColor"
              />
            )}
          />
          <ErrorMessage>{errors.headingFontColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderModelBackgroundColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Model Background Color
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Model Background Color is required',
            }}
            name="modelBackgroundColor"
            defaultValue={props.data?.modelBackgroundColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Model Background Color"
                name={name}
                value={value}
                onChange={onChange}
                id="modelBackgroundColor"
              />
            )}
          />
          <ErrorMessage>{errors.modelBackgroundColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderYearBackgroundColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Year Background Color
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Year Background Color is required',
            }}
            name="yearBackgroundColor"
            defaultValue={props.data?.yearBackgroundColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Year Background Color"
                name={name}
                value={value}
                onChange={onChange}
                id="yearBackgroundColor"
              />
            )}
          />
          <ErrorMessage>{errors.yearBackgroundColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderVariantBackgroundColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Variant Background Color
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Variant Background Color is required',
            }}
            name="variantBackgroundColor"
            defaultValue={props.data?.variantBackgroundColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Variant Background Color"
                name={name}
                value={value}
                onChange={onChange}
                id="variantBackgroundColor"
              />
            )}
          />
          <ErrorMessage>{errors.variantBackgroundColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderBorderColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">Grid Border Color</label>
          <Controller
            control={control}
            rules={{
              required: 'Grid Border Color is required',
            }}
            name="borderColor"
            defaultValue={props.data?.borderColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Grid Border Color"
                name={name}
                value={value}
                onChange={onChange}
                id="borderColor"
              />
            )}
          />
          <ErrorMessage>{errors.borderColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderExteriorBackgroundColor = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3">
          <label className="font-sm text-uppercase">
            Grid Exterior Background Color
          </label>
          <Controller
            control={control}
            rules={{
              required: 'Grid Header Background Color is required',
            }}
            name="exteriorBackgroundColor"
            defaultValue={props.data?.exteriorBackgroundColor}
            render={({ onChange, value, name }) => (
              <input
                type="text"
                className="form-control rounded-sm font-weight-semibold"
                placeholder="Grid Header Background Color"
                name={name}
                value={value}
                onChange={onChange}
                id="exteriorBackgroundColor"
              />
            )}
          />
          <ErrorMessage>{errors.exteriorBackgroundColor?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  const renderButton = () => {
    return (
      <div className="col-12">
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            type="button"
            className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            onClick={props.onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
            disabled={props.isSubmitting}
          >
            Update
          </button>
        </div>
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <div className="p-4">
        <h4 className="mb-3 font-weight-semibold">
          Update Vehicle Report Settings
        </h4>
        <div className="row gutter-10">
          {renderHeadingBackgroundColor()}
          {renderHeadingFontColor()}
          {renderModelBackgroundColor()}
          {renderYearBackgroundColor()}
          {renderVariantBackgroundColor()}
          {renderBorderColor()}
          {renderExteriorBackgroundColor()}
          <ErrorMessage>{props.error}</ErrorMessage>
          {renderButton()}
        </div>
      </div>
    </form>
  );
};

export default UpdateForm;
